// Повідомлення
export const selectMessages = state => state.liveChat.messages;

// Діалоги (канали)
export const selectChannels = state => state.liveChat.channels;

// Сесії чатів (таймери, статуси)
export const selectChatSessions = state => state.liveChat.sessions;

// Користувачі, з ким ідуть діалоги
export const selectDialogueUsers = state => state.liveChat.dialogueUsers;

// Поточний активний чат
export const selectCurrentChat = state => state.liveChat.currentChat;

// Пагінація повідомлень
export const selectMessagesPagination = state =>
  state.liveChat.messagesPagination;

export const selectDialogueUsersIds = state => state.liveChat.dialogueUsersIds;

// ✅ Пагінація діалогів (нове)
export const selectDialoguePagination = state =>
  state.liveChat.dialoguesPagination;

// Чи є ще сторінки для діалогів
export const selectHasNextDialoguesPage = state =>
  state.liveChat.dialoguesPagination.hasNextPage;

// Чи є попередня сторінка
export const selectHasPreviousDialoguesPage = state =>
  state.liveChat.dialoguesPagination.hasPreviousPage;

// Поточна сторінка діалогів
export const selectCurrentDialoguesPage = state =>
  state.liveChat.dialoguesPagination.page;

// Кількість діалогів на сторінку
export const selectDialoguesPerPage = state =>
  state.liveChat.dialoguesPagination.perPage;
